export default __webpack_public_path__ + "static/media/org_email.37ba5fac.svg";